import { render, staticRenderFns } from "./SaltEdgeModal.vue?vue&type=template&id=a4e5407c&"
import script from "./SaltEdgeModal.vue?vue&type=script&lang=js&"
export * from "./SaltEdgeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports